import { ImportField } from 'app/core/services/contact-import/contact-import.types';

/** A field a column can be matched to, as the mapping select offers it. */
export interface ImportFieldOption {
  value: ImportField;
  /** i18n key of its label. */
  label: string;
  /** Several columns may feed it (each value becomes a channel). */
  repeatable: boolean;
  /** Header the template writes for it, in Spanish so the auto-match recognizes it. */
  templateHeader: string;
  /** A sample value for the template's example row. */
  example: string;
}

const field = (
  value: ImportField,
  templateHeader: string,
  example: string,
  repeatable = false
): ImportFieldOption => ({
  value,
  label: `IMPORT_FIELD_${value}`,
  repeatable,
  templateHeader,
  example,
});

/** Every field, in the order the select and the template list them (§6 of the spec). */
export const IMPORT_FIELDS: ImportFieldOption[] = [
  field('CONTACT_TYPE', 'Tipo de contacto', 'Persona'),
  field('FIRST_NAME', 'Nombres', 'María José'),
  field('LAST_NAME', 'Apellidos', 'Cedeño Vera'),
  field('LEGAL_NAME', 'Razón social', ''),
  field('SUFFIX', 'Sufijo', ''),
  field('TRADE_NAME', 'Nombre comercial', ''),
  field('IDENTIFICATION', 'Cédula o RUC', '0915678239'),
  field('PASSPORT', 'Pasaporte', ''),
  field('BIRTHDATE', 'Fecha de nacimiento o constitución', '14/03/1988'),
  field('GENDER', 'Género', 'Mujer'),
  field('TITLE', 'Título', 'Ing.'),
  field('MARITAL_STATUS', 'Estado civil', 'Casado/a'),
  field('NATIONALITY', 'Nacionalidad', 'Ecuatoriana'),
  field('TAXPAYER_TYPE', 'Tipo de contribuyente', 'General'),
  field('PHONE', 'Teléfono', '0987654321', true),
  field('EMAIL', 'Correo', 'mjcedeno@gmail.com', true),
  field('WEBSITE', 'Página web', ''),
  field('ADDRESS1', 'Dirección', 'Av. 9 de Octubre 100'),
  field('NUMBER', 'Número', ''),
  field('ADDRESS2', 'Intersección', ''),
  field('CITY', 'Ciudad', 'Guayaquil'),
  field('STATE', 'Provincia', 'Guayas'),
  field('COUNTRY', 'País', 'Ecuador'),
  field('POSTCODE', 'Código postal', ''),
  field('ADDRESS_NOTE', 'Referencia', ''),
  field('SECTOR', 'Sector', ''),
  field('SEGMENT', 'Segmento', ''),
  field('CATEGORIES', 'Categorías', ''),
  field('NOTE', 'Observaciones', 'Cliente desde 2019'),
];

/** The select's options: "No importar" first, then every field. */
export const IMPORT_FIELD_OPTIONS: { value: ImportField; label: string }[] = [
  { value: 'IGNORE', label: 'IMPORT_FIELD_IGNORE' },
  ...IMPORT_FIELDS.map(({ value, label }) => ({ value, label })),
];

/** Whether several columns may be matched to the field. */
export function isRepeatableField(value: ImportField): boolean {
  return IMPORT_FIELDS.some((option) => option.value === value && option.repeatable);
}

/** i18n key of a field's label. */
export function importFieldLabel(value: string): string {
  return `IMPORT_FIELD_${value}`;
}

/** i18n key of a contact type id, as the review's type select shows it. */
export const IMPORT_CONTACT_TYPES = [
  { value: 151, label: 'PERSON' },
  { value: 152, label: 'ORG_PRIVATE' },
  { value: 153, label: 'ORG_PUBLIC' },
];
